import { FooterExample, FooterExample2 } from "../../../../../../packages/design-system/src/Footer/readme-helpers";
import * as React from 'react';
export default {
  FooterExample,
  FooterExample2,
  React
};